import React, { useState, useRef, useEffect } from 'react';
import API_BASE_URL from '../config';
import '../App.css';

export default function UploadInsights() {

  useEffect(() => {
    document.title = "Upload Insights | Outstanding Workplaces";
  }, []);

  const [form, setForm] = useState({
    name: '',
    designation: '',
    company: '',
    linkedin: '',
    message: '',
    image: null,
    video: null,
  });
  const [submitting, setSubmitting] = useState(false);
  const [thankYou, setThankYou] = useState(false);

  const handleChange = e => {
    const { name, value, type, files } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'file' ? files[0] : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (value) data.append(key, value);
      });

      const res = await fetch(`${API_BASE_URL}/api/admin/insights/upload`, {
        method: 'POST',
        body: data
      });
      const result = await res.json();
      if (res.ok && result.success) {
        setThankYou(true);
        setSubmitting(false);
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      } else {
        setSubmitting(false);
        alert('Submission failed: ' + (result.error || 'Unknown error'));
      }
    } catch (err) {
      setSubmitting(false);
      alert('Network or server error.');
      console.error(err);
    }
  };

  return (
    <section className="upload-insights-container">
      <div className="upload-insights-card">
        <h2 className="upload-insights-title">Upload your articles, blogs, or thoughts.</h2>
        <p className="upload-insights-subtitle">
          We'll feature them on our social media and website.
        </p>

        <form onSubmit={handleSubmit}>
          <h3 className="upload-form-title">Share your knowledge and get visibility!</h3>

          <div className="upload-form-grid">
            <div className="upload-form-group">
              <label>Name*</label>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                required
                onChange={handleChange}
              />
            </div>
            <div className="upload-form-group">
              <label>Designation*</label>
              <input
                type="text"
                name="designation"
                placeholder="Your Designation"
                value={form.designation}
                required
                onChange={handleChange}
              />
            </div>
            <div className="upload-form-group">
              <label>Company Name*</label>
              <input
                type="text"
                name="company"
                placeholder="Company Name"
                value={form.company}
                required
                onChange={handleChange}
              />
            </div>
            <div className="upload-form-group">
              <label>LinkedIn Profile</label>
              <input
                type="url"
                name="linkedin"
                placeholder="LinkedIn URL"
                value={form.linkedin}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="upload-form-group upload-full-width">
            <label>Message*</label>
            <textarea
              name="message"
              placeholder="Share your thoughts..."
              value={form.message}
              required
              onChange={handleChange}
              rows="4"
            ></textarea>
          </div>

          <div className="upload-form-grid">
            <div className="upload-form-group">
              <label>Upload Your Image</label>
              <input type="file" accept="image/*" onChange={handleChange} name="image" />
            </div>
            <div className="upload-form-group">
              <label>Upload Video</label>
              <input type="file" accept="video/*" onChange={handleChange} name="video" />
            </div>
          </div>

          <button type="submit" className="upload-submit-btn" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit"}
          </button>
          {thankYou && (
            <div className="upload-thankyou-msg">
              Thank you for your submission!
            </div>
          )}
        </form>
      </div>
    </section>
  );
}